import React from "react";
// import * as htmlToImage from "html-to-image";

import NewButton from "../../components/uiMerge/newButton";
import { message } from 'antd';

interface ScreenshotButtonProps {
  targetRef: React.RefObject<HTMLElement>;
  fileName?: string;
  variant?: any;
  text?: string;
}

const createFileName = (extension = "", ...names: string[]) => {
  if (!extension) {
    return "";
  }
  return `${names.join("")}.${extension}`;
};

const downloadFile = (image: string, { name = "screenshot", extension = "jpg" } = {}) => {
  const a = document.createElement("a");
  a.href = image;
  a.download = createFileName(extension, name);
  a.click();
};

const CaptureButton: React.FC<ScreenshotButtonProps> = ({
  targetRef,
  fileName = "screenshot",
  variant = "outline",
  text = "Save to Phone",
}) => {
  const htmlToImage = require("html-to-image");
  const handleDownload = async () => {
    if (!targetRef.current) return;

    const key = 'capture-updatable';

    // Show loading message
    message.loading({
      content: 'Downloading...',
      key,
      style: { zIndex: 9999 }
    });

    try {
      await htmlToImage.toJpeg(targetRef.current).then((dataUrl: string) =>
        downloadFile(dataUrl, { name: fileName, extension: "jpg" })
      );

      // Show success message
      message.success({
        content: `Downloaded Successfully!`,
        key,
        duration: 5,
        style: { zIndex: 9999 }
      });
    } catch (error) {
      console.error("Screenshot failed:", error);

      // Show error message
      message.error({
        content: 'Failed to save screenshot',
        key,
        duration: 5,
        style: { zIndex: 9999 }
      });
    }
  };

  return (
    <NewButton
      fullWidth
      variant={variant}
      onClick={handleDownload}>
      {text}
    </NewButton>
  );
};

export default CaptureButton;


